// @file fetch link with json api
import { jsonApiFetch, JsonAPIResponse } from './json_api_fetch'
import { Link } from './types'

export interface FetchLinkOptions {
  wallPublicKey?: string
}

/**
 * Fetch a link object and response in Json API format
 * @param url url to fetch
 * @param options optional fetch options
 */
export default function fetchLink(url: string, options: FetchLinkOptions = {}): Promise<JsonAPIResponse<Link>> {
  const query: Record<string, string> = { url }
  if (options.wallPublicKey) query.wall_public_key = options.wallPublicKey
  return jsonApiFetch<Link>('links', { query })
}
